import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../redux/hooks.js';
import { errorStatusSelector } from '../../../views/Login/loginSlice.js';
import { useOptimizelyExperiment } from '../../../redux/core/experiments/useOptimizelyExperiment.js';
import { PasswordlessLoginExperimentKey } from '../../../redux/core/experiments/allExperiments/passwordlessLogin.js';
import { isPasswordlessEnabledSelector } from '../../../redux/core/siteConfig/siteConfigSlice.js';
export const LoginNegativeAlert = () => {
    const { t } = useTranslation();
    const errorStatus = useAppSelector(errorStatusSelector);
    const isPasswordlessEnabled = useAppSelector(isPasswordlessEnabledSelector);
    const isPasswordlessExperimentEnabled = useOptimizelyExperiment(PasswordlessLoginExperimentKey) === 'B';
    const isPasswordlessLogin = isPasswordlessExperimentEnabled || isPasswordlessEnabled;
    const errorMessage = isPasswordlessLogin
        ? t('loginregistration.login.error.wrongPasswordWithPasswordless')
        : t('loginregistration.login.error.wrongPassword');
    return (_jsx(_Fragment, { children: errorStatus && (_jsx(Alert, { variant: 'negative', role: 'alert', children: errorMessage })) }));
};
//# sourceMappingURL=LoginNegativeAlert.js.map